import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=b9407f2c&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=b9407f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9407f2c",
  null
  
)

export default component.exports